/**
 * Onde a imagem de capa do produto sai na folha do Orçamento (§11.2, `idTipoImpressaoImagem`).
 * Espelha db_vendas.tipo_impressao_imagem.
 */
export enum TipoImpressaoImagemEnum {
    NaoImprimir = 1,
    AoLadoDaDescricao = 2,
    EmSecaoSeparada = 3,
}
